import React, {Component} from 'react'
import propTypes from 'prop-types'
import {get, isNil} from 'lodash'
import TextField from '@material-ui/core/TextField'
import PriceListTreeViewContainer from 'scenes/quotingScene/components/priceListTreeView'
import Button from 'components/button'
import Dialog from 'components/dialog'
import {TextFormField} from 'components/formField'
import {prefix} from 'helpers/component'
import {nullPartCategory} from 'helpers/parts'
import {getPartCategoryNameBreadcrumbs} from 'helpers/partCategories'
import './partCategoryTreeSelectField.scss'

class PartCategoryTreeSelectField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isPopOverVisible: false,
      anchorEl: null,
      categoryDirection: null,
      pendingSelectedPartCategories: [],
    }
    this.getClass = prefix('part-category-select-field-')
  }

  componentDidMount() {
    const {onLoadPriceLists, onLoadPartCategories, onLoadAllPartCategories} = this.props
    onLoadPriceLists()
    onLoadPartCategories()
    onLoadAllPartCategories()
  }

  handleTouchTap = (event) => {
    event.preventDefault()
    this.setState({
      isPopOverVisible: true,
      anchorEl: event.currentTarget,
    })
  }

  handleRequestClose = () => {
    this.setState({
      isPopOverVisible: false,
      categoryDirection: null,
    }, () => {
      const {onClearPendingSelectedPartCategories} = this.props
      if (!isNil(onClearPendingSelectedPartCategories)) {
        onClearPendingSelectedPartCategories(this.state.pendingSelectedPartCategories)
      }
    })
  }

  onCancel = () => {
    this.handleRequestClose()
  }

  onSelect = () => {
    this.handleRequestClose()
    this.props.onSave()
  }

  getErrorText = (partCategory, required) => {
    const {errorText} = this.props
    let name = get(partCategory, 'name', null)
    if (isNil(name))
      name = get(partCategory, 'label', null)

    return required
      ? isNil(name) ? 'This field is mandatory' : errorText
      : errorText
  }

  getTextField = (errorText) => {
    const {
      partCategoryRef,
      isInEditableFieldList,
      partCategory,
      fullWidth,
      readOnly,
      required,
      floatingLabelText,
      partCategories,
    } = this.props

    const partCategoryName = getPartCategoryNameBreadcrumbs(partCategory, partCategories)

    return isInEditableFieldList
      ? (
        <TextFormField
          key={'part-category'}
          ref={partCategoryRef}
          formFieldClassName={'part-category'}
          floatingLabelText={floatingLabelText}
          value={partCategoryName}
          showLabel={false}
          multiLine={true}
          fullWidth={fullWidth}
          readOnly={readOnly}
          required={required}
          errorText={errorText}
          onFocus={this.handleTouchTap}
        />
      )
      : (
        <TextField
          key={'part-category'}
          inputRef={partCategoryRef}
          className={'part-category'}
          label={floatingLabelText}
          value={partCategoryName}
          multiline={true}
          fullWidth={fullWidth}
          required={required}
          error={!!errorText}
          helperText={errorText || undefined}
          InputProps={{readOnly}}
          onFocus={this.handleTouchTap}
        />
      )
  }

  onSelectFolder = (folder) => {
    const {onCheck} = this.props

    this.setState({isPopOverVisible: false})
    onCheck(folder)
  }

  render() {
    const {required, partCategory} = this.props
    const {isPopOverVisible} = this.state

    const errorText = this.getErrorText(partCategory, required)

    return (
      <div className={this.getClass('container')}>
        {this.getTextField(errorText)}
        <Dialog
          className={this.getClass('pop-over')}
          title="Select Part Category"
          actions={null}
          modal={false}
          visible={isPopOverVisible}
          width={626}
          onRequestClose={this.handleRequestClose}
          autoScrollBodyContent={false}
        >
          <div className={'tree-view'}>
            <PriceListTreeViewContainer
              categoryId={get(partCategory, 'id', null)}
              priceListId={get(partCategory, 'priceListId', null)}
              onSelectFolder={this.onSelectFolder}
              selectFolderDisabled={true}
              isActionsHidden={true}
              isAddHidden={true}
              isCategoryDetailsHidden={true}
              isRootNodeSelectDisabled={true}
              sidebarMaxHeight={550}
              categoryLabelMaxLength={100}
            />
          </div>
          <div className={this.getClass('actions')}>
            <div className={'right'}>
              <Button
                key={'cancel-part-category-selection'}
                className={'cancel-part-category-selection'}
                label={'Cancel'}
                flat={true}
                onClick={this.onCancel}
              />
            </div>
          </div>
        </Dialog>
      </div>
    )
  }
}

PartCategoryTreeSelectField.propTypes = {
  partCategoryRef: propTypes.any,
  floatingLabelText: propTypes.string,
  readOnly: propTypes.bool.isRequired,
  required: propTypes.bool,
  partCategories: propTypes.array,
  priceListId: propTypes.number,
  priceList: propTypes.object,
  categoryId: propTypes.number,
  category: propTypes.object,
  priceLists: propTypes.array.isRequired,
  categories: propTypes.array,
  parentCategories: propTypes.array,
  selectedPartCategories: propTypes.array,
  disabledPartCategories: propTypes.array,
  search: propTypes.string,
  partCategory: propTypes.object,
  isNodeSelectable: propTypes.bool,
  isMultiSelectable: propTypes.bool,
  isInEditableFieldList: propTypes.bool,
  fullWidth: propTypes.bool.isRequired,
  errorText: propTypes.string,
  onChange: propTypes.func,
  onCheck: propTypes.func,
  onLoadAllPartCategories: propTypes.func.isRequired,
  onLoadPriceLists: propTypes.func.isRequired,
  onLoadPartCategories: propTypes.func.isRequired,
  onSelectAllPriceLists: propTypes.func.isRequired,
  onSelectPriceList: propTypes.func.isRequired,
  onSelectCategory: propTypes.func.isRequired,
  onSearch: propTypes.func.isRequired,
  onClearPendingSelectedPartCategories: propTypes.func,
  onSave: propTypes.func,
}

PartCategoryTreeSelectField.defaultProps = {
  floatingLabelText: 'Part Category',
  partCategory: nullPartCategory,
  readOnly: false,
  required: false,
  fullWidth: true,
  isNodeSelectable: false,
  isMultiSelectable: false,
  isInEditableFieldList: false,
  partCategories: [],
  priceLists: [],
  categories: [],
  parentCategories: [],
  selectedPartCategories: [],
  disabledPartCategories: [],
}

export default PartCategoryTreeSelectField
